import {HttpContextToken} from "@angular/common/http";

export const HTTPContextNoRetry = new HttpContextToken(() => false)
